<template>
    <div class="atmo-content-group">
        <AccordionItem :visible="$route.hash === '#second-proposal-contract'" title="Предложить заключить контракт второму поставщику" header-class="fs-22" class="pb-0">
            <fl44-unknown-volume-select-second-proposal-table v-model="form.selected_proposal_id" :proposals="purchase.customer_select_second_proposal_data.actual_proposals" :v="$v.form.selected_proposal_id" />
            <template v-if="form.selected_proposal_id">
                <h5 class="grey-color fw-600">Информация о выбранном поставщике</h5>
                <text-row-link compact label="Наименование" v-model="selectedProposal.organization.full_name" :router-link="{ name: 'OrganizationShow', params: { id: selectedProposal.organization.id } }" />
                <text-row compact label="ИНН" v-model="selectedProposal.organization.inn" />
                <text-row compact label="КПП" v-model="selectedProposal.organization.kpp" />
                <text-row compact label="ОГРН" v-model="selectedProposal.organization.ogrn" />
                <text-row-single-document compact label="Карточка предприятия" v-model="selectedProposal.organization_card" />
                <text-row compact label="Рейтинг ИС" v-model="selectedProposal.organization.rating" />
                <text-row-single-document v-if="selectedProposal.commercial_proposal" compact label="Коммерческое предложение" v-model="selectedProposal.commercial_proposal" />
                <text-row-documents compact label="Дополнительные документы, приложенные поставщиком к предложению" v-model="selectedProposal.documents" v-if="selectedProposal.documents > 0" />
                <text-row-raw label="Требования к участникам закупки" compact>
                    <ul class="fs-14 grey-color my-auto col-form-label">
                        <li v-if="selectedProposal.supplier_requirements_confirmed.supplier_reqs_a">
                            <i class="atmo-icon-checkbox"></i>&nbsp;Поставщик подтвердил, что соответствует требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ.
                            <ul>
                                <li>Документы, подтверждающие соответствие требованиям:</li>
                                <li v-for="(document, index) in selectedProposal.supplier_requirements_confirmed.supplier_required_documents" :key="index">
                                    <ul class="ml-3">
                                        <li>
                                            {{ `${index + 1}. ${document.name} - ` }}
                                            <a class="fs-14 atmo-button-link" :href="$getAttachmentDownloadLink(document.storedDocument.id)" target="_blank">{{ document.storedDocument.name }}</a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li v-if="selectedProposal.supplier_requirements_confirmed.supplier_reqs_b">
                            <i class="atmo-icon-checkbox"></i>&nbsp;Поставщик подтвердил, что соответствует требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ.
                        </li>
                        <li v-if="selectedProposal.supplier_requirements_confirmed.supplier_reqs_c">
                            <i class="atmo-icon-checkbox"></i>&nbsp;Поставщик подтвердил, что соответствует требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ.
                        </li>
                        <li v-if="selectedProposal.supplier_requirements_confirmed.supplier_reqs_sonko"><i class="atmo-icon-checkbox"></i>&nbsp;Поставщик подтвердил, что является <abbr title="Социально ориентированная некоммерческая организация">СОНКО</abbr>.</li>
                        <li v-if="!!selectedProposal.supplier_requirements_confirmed.additional_requirements && selectedProposal.supplier_requirements_confirmed.additional_requirements.length > 0">
                            <i class="atmo-icon-checkbox"></i>&nbsp;Поставщик подтвердил соответствие дополнительным требованиям приложив следующие документы:
                            <ul>
                                <li v-for="(requirement, index) in selectedProposal.supplier_requirements_confirmed.additional_requirements" :key="index">
                                    <ul class="ml-3">
                                        <li>
                                            {{ `${index + 1}. ${requirement.description} (Причина: ${requirement.reason}) - ` }}
                                            <a class="fs-14 atmo-button-link" :href="$getAttachmentDownloadLink(requirement.attachment.id)" target="_blank">{{ requirement.attachment.name }}</a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </text-row-raw>
                <text-row-proposal-specification-table v-model="selectedProposal.deliverables" :without-vat="selectedProposal.without_vat">
                    <template #header>
                        <span class="fs-14 fw-600" style="padding-left: 5px;">Спецификация:</span>
                    </template>
                </text-row-proposal-specification-table>
                <limits-editable-table
                    v-if="features.kbk_limits && !purchase.purchase_terms.without_limits"
                    v-model="form.limits"
                    :total-cost="purchase.purchase_terms.contract_price"
                    @validate="limitsValidate"
                    :limit-year="purchase.purchase_terms.purchase_limit_year"
                    :order-type="purchase.purchase_terms.order_type"
                    purchase-type="fl44_unknown_volume"
                    :purchase-id="purchase.id">
                    <template #title>
                        <h5 class="grey-color fw-600">Измените лимиты</h5>
                    </template>
                    <template #label-hint>
                        Добавьте или измените лимиты. Необходимо полностью распределить цену контракта по соответствующим лимитам.
                    </template>
                </limits-editable-table>
                <form-row-contract-upload v-model="form.contract_attachment" :label-cols-lg="3" :v="$v.form.contract_attachment" send-title="Отправить контракт" title="Контракт" />
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button :disabled="!isValid" variant="custom-green" class="text-uppercase ml-1" @click="storeSecondContract">Отправить контракт</b-button>
                </b-overlay>
            </template>
        </AccordionItem>
    </div>
</template>

<script>
import Config from '@core/js/ddriven/application/config/Config';
import { required } from 'vuelidate/lib/validators';
import AccordionItem from '@/components/common/accordion-item.vue';
import Fl44UnknownVolumeSelectSecondProposalTable from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-select-second-proposal-table.vue';
import TextRowProposalSpecificationTable from '@/components/proposals/partials/text-row-proposal-specification-table.vue';
import FormRowContractUpload from '@/components/common/form-rows/form-row-contract-upload.vue';

export default {
    name: 'fl44-unknown-volume-send-second-proposal-contract',
    components: {
        FormRowContractUpload,
        TextRowProposalSpecificationTable,
        Fl44UnknownVolumeSelectSecondProposalTable,
        AccordionItem,
    },
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.form.limits = this.purchase.customer_select_second_proposal_data.limits;
        if (this.purchase.customer_select_second_proposal_data.actual_proposals.length === 1) {
            this.form.selected_proposal_id = this.purchase.customer_select_second_proposal_data.actual_proposals[0].id;
        }
    },
    data() {
        return {
            isDataSending: false,
            isLimitsValid: false,
            form: {
                selected_proposal_id: null,
                contract_attachment: null,
                limits: []
            }
        };
    },
    validations: {
        form: {
            selected_proposal_id: { required },
            contract_attachment: { required }
        }
    },
    methods: {
        async storeSecondContract() {
            this.isDataSending = true;
            await this.$api.personal.fl44UnknownVolume
                .storeSecondContract(this.purchase.id, this.form)
                .then((response) => {
                    if (response) {
                        this.$emit('refresh', this.$route.hash !== '#atmo-contract' ? '#atmo-contract' : null);
                    }
                })
                .finally(() => {
                    this.isDataSending = false;
                });
        },
        limitsValidate(value) {
            this.isLimitsValid = !value;
        }
    },
    computed: {
        features() {
            return Config.get('theme.features');
        },
        isValid() {
            const kbkLimits = this.features.kbk_limits ? this.isLimitsValid || this.purchase.purchase_terms.without_limits : true;
            console.log(kbkLimits);
            return kbkLimits && !this.$v.$invalid;
        },
        selectedProposal() {
            return this.purchase.customer_select_second_proposal_data.actual_proposals.find((item) => item.id === this.form.selected_proposal_id);
        }
    }
};
</script>
